import React from "react";
import GoldDomain from "../components/GoldDomain/GoldDomain";
import TopBar from "../components/TopBar";
import Footerr from "../components/Footerr/Footerr";
import ProgressBar from "../components/ProgressBar";

function Gold() {
  return (
    <div>
      <ProgressBar />
      <TopBar />
      <GoldDomain />
      <Footerr />
    </div>
  );
}

export default Gold;
